import { DashboardShell } from "@/components/dashboard-shell";
import { DashboardProvider } from "@/components/home/dashboard-context";
import { HqHeader } from "@/components/home/hq-header";
import { TodaySchedule } from "@/components/home/today-schedule";
import { CombinedTodo } from "@/components/home/combined-todo";
import { NeedsAttention } from "@/components/home/needs-attention";
import { FocusStrip } from "@/components/home/focus-strip";
import { DeleteRequests } from "@/components/deletions/delete-requests";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: DashboardPage,
});

// Home answers "what do I do now?": the focus tiles, then the to-do list and
// calendar, then the triage queue. Home is today's work only. Pipeline, leads and health live on their own pages.
function DashboardPage() {
  return (
    <DashboardShell>
      <DashboardProvider>
        <HqHeader />

        {/* The answer to "what needs me?": counts that jump to their rows below. */}
        <FocusStrip />

        {/* Fixed height on desktop: both lists scroll inside their card. The
            to-do list leads (it is what you act on); the calendar sits beside
            it on desktop and after it when stacked. */}
        <div className="grid w-full grid-cols-1 gap-4 max-md:gap-3 lg:h-[44rem] lg:grid-cols-12">
          <div className="min-w-0 scroll-mt-4 lg:col-span-8 lg:min-h-0">
            <CombinedTodo />
          </div>
          <div className="min-w-0 lg:col-span-4 lg:min-h-0">
            <TodaySchedule />
          </div>
        </div>

        <NeedsAttention />

        {/* What the agent asked to delete; only a person's click deletes it. */}
        <DeleteRequests />

        {/* Room for the floating Quick log button, so it never covers the last row. */}
        <div aria-hidden="true" className="h-14 shrink-0 md:hidden" />
      </DashboardProvider>
    </DashboardShell>
  );
}
